/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-12-21 16:52:23
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-01-13 15:49:27
 */

export default {
  path: 'login',
  component: () => import(/* webpackChunkName: "login" */ '@/pages/passport/Login'),
}